import { render, staticRenderFns } from "./UserTrendChart.vue?vue&type=template&id=ba3fb802"
import script from "./UserTrendChart.vue?vue&type=script&lang=js"
export * from "./UserTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports